import { Component, Vue } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'

@Component({
	components: {
		Loader,
	},
})
export default class LatestPosts extends Vue {
	blogPosts = [] as Array<any>
	loading = true

	openLink(url) {
		window.open(url, '_blank')
	}

	loadBlogPosts() {
		this.blogPosts.length = 0
		const url =
			'https://locatelliadv.com.br/wp-json/wp/v2/posts?per_page=3&status=publish&categories=3'

		fetch(url, {
			method: 'GET',
			headers: {
				Authorization:
					'Basic YWRtaW4ubGxhYzpkcURhIGNVRkkgUkJLUiBsbGdxIHpHNUMgb054Zw==',
			},
		})
			.then((response) => response.json())
			.then((data) => {
				data.forEach((item) => {
					const post = {
						date: new Intl.DateTimeFormat('pt-BR').format(
							new Date(item.date),
						),
						text: item.excerpt.rendered,
						link: item.link,
						title: item.title.rendered,
						image: item.jetpack_featured_media_url,
					}

					this.blogPosts.push(post)
				})

				this.loading = false
			})
	}

	mounted() {
		this.loadBlogPosts()
	}
}
